<template>
  <div class="favorites-page">
    <header class="page-header">
      <h1 class="page-title">Mina favoriter</h1>
      <p v-if="!isLoading" class="page-meta">
        {{ favorites.length }} sparade event
      </p>
    </header>

    <div v-if="isLoading" class="state">
      <p>Laddar…</p>
    </div>

    <div v-else-if="!favorites.length" class="state empty-state">
      <p class="empty-title">Inga favoriter än</p>
      <p class="empty-sub">
        Klicka på hjärtat på ett event för att spara det här.
      </p>
      <router-link to="/" class="empty-cta">Bläddra event</router-link>
    </div>

    <div v-else class="events-grid">
      <EventCard
        v-for="(event, i) in mapped"
        :key="event._id || i"
        :event="event"
        @show-event-info="showEventBar"
      />
    </div>

    <!-- Event info sidebar -->
    <div
      v-if="showEventInfo"
      class="sidebar-overlay"
      @click="showEventInfo = false"
    ></div>
    <div class="event-sidebar" :class="showEventInfo ? 'show' : ''">
      <event-info
        v-if="showEventInfo"
        :chosen-event="chosenEvent"
        @close="showEventInfo = false"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EventCard from "@/components/event-card.vue";
import EventInfo from "@/components/event-info.vue";
import { loadFavoriteIds } from "@/utils/favorites";

export default {
  name: "MyFavorites",
  components: { EventCard, EventInfo },
  data() {
    return {
      isLoading: true,
      favorites: [],
      showEventInfo: false,
      chosenEvent: null,
    };
  },
  computed: {
    mapped() {
      // Plattar ut till samma form som EventCard förväntar sig. Backend
      // returnerar nu både concert- och external-favoriter via samma
      // f.event-fält (med _isExternal-flagga satt för externa).
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return this.favorites
        .map((f) => f.event)
        .filter((c) => c && new Date(c.date) >= today);
    },
  },
  methods: {
    async fetchFavorites() {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL + "favorites",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        this.favorites = data;
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          this.$router.push("/login");
          return;
        }
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    showEventBar(event) {
      this.chosenEvent = event;
      this.showEventInfo = true;
    },
  },
  async created() {
    // Säkerställ att favorit-id-cachen är fräsch (för hjärt-state)
    await loadFavoriteIds();
    await this.fetchFavorites();
  },
};
</script>

<style scoped>
.favorites-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 3rem 2rem 5rem;
}

.page-header {
  margin-bottom: 2.5rem;
}

.page-title {
  font-family: "Playfair Display", serif;
  font-weight: 900;
  font-size: clamp(2rem, 5vw, 4rem);
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: -0.02em;
  margin-bottom: 0.5rem;
}

.page-meta {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 2rem;
}

.state {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--color-text-secondary);
}

.empty-state .empty-title {
  font-family: "Playfair Display", serif;
  font-size: 1.5rem;
  font-weight: 900;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.empty-state .empty-sub {
  margin-bottom: 1.5rem;
}

.empty-cta {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background: var(--color-accent);
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
